/** @format */

import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import React, { useEffect } from 'react';
import { PAGES_MENU } from '../../../Constants/commons';
import { NavLink, useLocation } from 'react-router-dom';
import { useAppContext } from '../../../store/store.app';

export const BTM_NAV_HEI = '56px';

function BottomBar() {
  const [activeTab, setActiveTab] = React.useState();
  const location = useLocation();

  const {
    appStore: { userInfo },
  } = useAppContext();

  function handleActiveTab() {
    const path = location.pathname.split('/')[1];
    const index = PAGES_MENU.findIndex((page) => page.linkText === path);
    setActiveTab(index);
  }

  useEffect(() => {
    handleActiveTab();
  }, [location]);

  if (!userInfo) return <></>;

  const { pages } = userInfo;

  //Bypassing for now for biz barometr as it is not in the user details

  // const pagesToShow = pages.reduce((acc, curr) => {
  //   const { display } = curr;
  //   if (!display) return acc;
  //   const matched = PAGES_MENU.find((page) => page.linkText === curr.link);
  //   if (!matched)
  //     console.error(
  //       'Page listed in param is not in corresponding constant file'
  //     );
  //   else acc.push(matched);
  //   return acc;
  // }, []);

  const pagesToShow = PAGES_MENU.filter((page) => page.enabled);

  return (
    <Paper
      className="no-print"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: { md: 'none' },
      }}
      elevation={3}
    >
      <BottomNavigation
        sx={{ height: BTM_NAV_HEI }}
        showLabels
        value={activeTab}
      >
        {pagesToShow.map((page) => {
          return (
            <BottomNavigationAction
              key={page.id}
              label={page.displayText}
              icon={<page.Icon />}
              component={NavLink}
              to={page.linkText}
            />
          );
        })}
      </BottomNavigation>
    </Paper>
  );
}

export default BottomBar;
